module.exports = __webpack_public_path__ + "img/dmg.d766b9b8.png";